import React from 'react';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';

import DropdownRemote from '../../../../DropdownRemote';
import { TYPES } from '../../../../../../actions/availableLinkedRecordActions';
import useDropdownBehaviour from '../../hooks/useDropdownBehavior.hook';

import styles from './links.less';

const Selector = (props) => {
  const { t } = useTranslation();
  const enableSelect = props.config.get('enableSelect');
  const enableCreate = props.config.get('enableCreate');
  const placeholder = t('record.fields.object.add') || props.placeholder;
  const { dropdownClassName, visible, selectItem, visibleChange } = useDropdownBehaviour({
    className: styles.dropdownRemote,
    onSelectItem: props.onAddItem,
    onVisibleChange: props.onVisibleChange,
  });

  if (props.type === TYPES.LINKED_OBJECTS) {
    if (!enableSelect && !enableCreate) {
      return null;
    }

    if (!enableSelect && props.additionalItems && props.additionalItems.length < 2) {
      const item = props.additionalItems[0];

      return (
        <div className={cn(styles.selectorAdd, props.wrapperClassName)}>
          {item && item.children ? item.children({ linkProps: { children: item.text } }) : null}
        </div>
      );
    }
  }

  const getPopupContainer =
    props.getPopupContainer || props.containerRef ? () => props.containerRef.current : undefined;

  return (
    <div className={cn(styles.selector, props.wrapperClassName)}>
      <DropdownRemote
        placeholder={placeholder}
        className={dropdownClassName}
        showArrow={visible}
        open={visible || props.open}
        onVisibleChange={visibleChange}
        onSelectItems={selectItem}
        getPopupContainer={getPopupContainer}
        {...props}
      />
    </div>
  );
};

export default Selector;
